import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";

@Component({
  selector: "app-goverment-section",
  templateUrl: "./goverment-section.component.html",
  styleUrls: ["./goverment-section.component.css"],
})
export class GovermentSectionComponent implements OnInit {
  HtmlData:any;
  DocId:any;
  mainData:any;
  constructor(private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,) {
  }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    const url = this.global.basePath + "common/circularlist?modelType=aboutUs";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.mainData =res[0].json.circular;

      this.HtmlData = data[0].html;
      this.DocId = res[0].json.circular[0]._id

      setTimeout(() => {
        const table = document.getElementsByTagName("table");
        for (var i = 0; i < table.length; i++) {
          table[i].style.width = "100%";
          table[i].style.border = "1px solid #dbdbdb";
        }
        const td = document.getElementsByTagName("td");

        for (var i = 0; i < td.length; i++) {
          td[i].style.border = "1px solid #dbdbdb";
          td[i].style.padding = "10px";
        }
      }, 500);

    });
  }
}
